import { FilterToolbar } from '@/components/filter-toolbar';
import { useAIModelsQueryParams } from '@/modules/gpt-chats/hooks/use-aimodel';
import { useTranslation } from 'react-i18next';

type ModelsFilter = {
  search: string;
};
export const AIModelsFilterToolbar = () => {
  const { t } = useTranslation();
  const {
    queryParams: { search },
    setQueryParams,
  } = useAIModelsQueryParams();

  const changeHandler = (key: string, value: string) => {
    setQueryParams((params) => ({ ...params, [key]: value }));
  };

  const resetHandler = () => {
    setQueryParams(null);
  };

  return (
    <FilterToolbar<ModelsFilter>
      filters={[{ key: 'search', type: 'SearchInput', label: t('SEARCH') }]}
      values={{ search }}
      defaultValues={{ search: '' }}
      onChange={changeHandler}
      onReset={resetHandler}
    />
  );
};
